// import React from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Chip,
//   CircularProgress,
//   Box,
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import dayjs from 'dayjs';
// import {
//   tableStyles,
//   commonStyles,
//   getStatusColor,
//   getSeverityColor,
//   getTypeColor,
//   getEmailColor,
//   layoutStyles,
// } from '../styles';

// const NotificationTable = ({ 
//   notifications, 
//   loading, 
//   screenHeight, 
//   headerHeight, 
//   onViewNotification 
// }) => {
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           ...layoutStyles.loadingContainer,
//           height: `${screenHeight - headerHeight}px`,
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <TableContainer
//       className="main_table"
//       component={Paper}
//       sx={{
//         ...tableStyles.root,
//         ...tableStyles.container,
//         maxHeight: `${screenHeight - headerHeight}px`,
//       }}
//     >
//       <Table aria-label="notifications table">
//         <TableHead sx={tableStyles.stickyHeader}>
//           <TableRow>
//             <TableCell align="left">Plant Name</TableCell>
//             <TableCell align="left">Type</TableCell>
//             <TableCell align="left">Message</TableCell>
//             <TableCell align="center">Status</TableCell>
//             <TableCell align="center">Severity</TableCell>
//             <TableCell align="center">Created Date</TableCell>
//             <TableCell align="center">Email Status</TableCell>
//             <TableCell align="center">Actions</TableCell>
//           </TableRow>
//         </TableHead>
        
//         <TableBody>
//           {notifications.map((notification) => (
//             <TableRow key={notification.id}>
//               <TableCell align="left">
//                 <strong>{notification.plantName}</strong>
//               </TableCell>
              
//               <TableCell align="left">
//                 <Chip
//                   label={notification.type.replace(/_/g, ' ')}
//                   sx={{
//                     ...commonStyles.typeChip,
//                     backgroundColor: getTypeColor(notification.type),
//                     fontSize: '11px',
//                   }}
//                 />
//               </TableCell>
              
//               <TableCell align="left" sx={tableStyles.messageCell}>
//                 {notification.message}
//               </TableCell>
              
//               <TableCell align="center">
//                 <Chip
//                   label={
//                     notification.status.charAt(0).toUpperCase() +
//                     notification.status.slice(1)
//                   }
//                   sx={{
//                     ...commonStyles.chip,
//                     backgroundColor: getStatusColor(notification.status),
//                   }}
//                 />
//               </TableCell>
              
//               <TableCell align="center">
//                 <Chip
//                   label={
//                     notification.severity.charAt(0).toUpperCase() +
//                     notification.severity.slice(1)
//                   }
//                   sx={{
//                     ...commonStyles.chip,
//                     backgroundColor: getSeverityColor(notification.severity),
//                   }}
//                 />
//               </TableCell>
              
//               <TableCell align="center">
//                 <div>
//                   <div>
//                     {dayjs(notification.created_at).format('DD-MM-YYYY')}
//                   </div>
//                   <div style={tableStyles.dateCell}>
//                     {dayjs(notification.created_at).format('HH:mm:ss')}
//                   </div>
//                 </div>
//               </TableCell>
              
//               <TableCell align="center">
//                 <Chip
//                   label={notification.emailSent ? 'Sent' : 'Not Sent'}
//                   sx={{
//                     ...commonStyles.chip,
//                     backgroundColor: getEmailColor(notification.emailSent),
//                   }}
//                 />
//               </TableCell>
              
//               <TableCell align="center">
//                 <Button
//                   variant="contained"
//                   size="small"
//                   startIcon={<VisibilityIcon />}
//                   onClick={() => onViewNotification(notification)}
//                   sx={commonStyles.viewButton}
//                 >
//                   View
//                 </Button>
//               </TableCell>
//             </TableRow>
//           ))}
          
//           {notifications.length === 0 && (
//             <TableRow>
//               <TableCell colSpan={8} align="center" sx={tableStyles.emptyRow}>
//                 No notifications found
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default NotificationTable;


import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  CircularProgress,
  Box,
  Checkbox,
  Pagination,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CheckIcon from '@mui/icons-material/Check';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import dayjs from 'dayjs';
import {
  tableStyles,
  commonStyles,
  getStatusColor,
  getSeverityColor,
  getTypeColor,
  getEmailColor,
  layoutStyles,
} from '../styles';

const NotificationTable = ({ 
  notifications, 
  loading, 
  screenHeight, 
  headerHeight, 
  onViewNotification,
  pagination,
  onPageChange,
  onNotificationUpdate,
  onBulkUpdate
}) => {
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = notifications.map((n) => n.id);
      setSelectedNotifications(newSelecteds);
    } else {
      setSelectedNotifications([]);
    }
  };

  const handleSelectNotification = (event, id) => {
    event.stopPropagation();
    const selectedIndex = selectedNotifications.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedNotifications, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedNotifications.slice(1));
    } else if (selectedIndex === selectedNotifications.length - 1) {
      newSelected = newSelected.concat(selectedNotifications.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedNotifications.slice(0, selectedIndex),
        selectedNotifications.slice(selectedIndex + 1),
      );
    }

    setSelectedNotifications(newSelected);
  };

  const handleMenuOpen = (event, notificationId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedNotificationId(notificationId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedNotificationId(null);
  };

  const handleMarkAsResolved = async () => {
    if (selectedNotificationId) {
      await onNotificationUpdate(selectedNotificationId, {
        status: 'resolved',
        processed: true,
        resolutionTime: new Date(),
        resolutionDetails: 'Manually marked as resolved'
      });
    }
    handleMenuClose();
  };

  const handleMarkAsActive = async () => {
    if (selectedNotificationId) {
      await onNotificationUpdate(selectedNotificationId, {
        status: 'active',
        processed: false
      });
    }
    handleMenuClose();
  };

  const handleBulkMarkResolved = async () => {
    if (selectedNotifications.length > 0) {
      await onBulkUpdate(selectedNotifications, {
        status: 'resolved',
        processed: true,
        resolutionTime: new Date(),
        resolutionDetails: 'Bulk marked as resolved'
      });
      setSelectedNotifications([]);
    }
  };

  const handleBulkMarkProcessed = async () => {
    if (selectedNotifications.length > 0) {
      await onBulkUpdate(selectedNotifications, {
        processed: true
      });
      setSelectedNotifications([]);
    }
  };

  const isSelected = (id) => selectedNotifications.indexOf(id) !== -1;

  if (loading && notifications.length === 0) {
    return (
      <Box
        sx={{
          ...layoutStyles.loadingContainer,
          height: `${screenHeight - headerHeight}px`,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {/* Bulk Actions */}
      {selectedNotifications.length > 0 && (
        <Box sx={{ mb: 2, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {selectedNotifications.length} notification(s) selected
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button
              size="small"
              variant="contained"
              startIcon={<CheckIcon />}
              onClick={handleBulkMarkResolved}
              sx={commonStyles.primaryButton}
            >
              Mark as Resolved
            </Button>
            <Button
              size="small"
              variant="outlined"
              startIcon={<PlaylistAddCheckIcon />}
              onClick={handleBulkMarkProcessed}
            >
              Mark as Processed
            </Button>
            <Button
              size="small"
              variant="text"
              onClick={() => setSelectedNotifications([])}
            >
              Clear Selection
            </Button>
          </Box>
        </Box>
      )}

      {/* Table */}
      <TableContainer
        className="main_table"
        component={Paper}
        sx={{
          ...tableStyles.root,
          ...tableStyles.container,
          maxHeight: `${screenHeight - headerHeight - (selectedNotifications.length > 0 ? 100 : 0)}px`,
        }}
      >
        <Table aria-label="notifications table">
          <TableHead sx={tableStyles.stickyHeader}>
            <TableRow>
              <TableCell padding="checkbox">
                {/* <Checkbox
                  color="primary"
                  indeterminate={selectedNotifications.length > 0 && selectedNotifications.length < notifications.length}
                  checked={notifications.length > 0 && selectedNotifications.length === notifications.length}
                  onChange={handleSelectAll}
                /> */}
              </TableCell>
              <TableCell align="left">Plant Name</TableCell>
              <TableCell align="left">Type</TableCell>
              <TableCell align="left">Message</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Severity</TableCell>
              <TableCell align="center">Created Date</TableCell>
              {/* <TableCell align="center">Email Status</TableCell> */}
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          
          <TableBody>
            {notifications.map((notification) => {
              const isItemSelected = isSelected(notification.id);
              
              return (
                <TableRow 
                  key={notification.id}
                  hover
                  onClick={(event) => handleSelectNotification(event, notification.id)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  selected={isItemSelected}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      onChange={(event) => handleSelectNotification(event, notification.id)}
                    />
                  </TableCell>
                  
                  <TableCell align="left">
                    <strong>{notification.plantName}</strong>
                  </TableCell>
                  
                  <TableCell align="left">
                    <Chip
                      label={notification.type.replace(/_/g, ' ')}
                      sx={{
                        // ...commonStyles.typeChip,
                        // backgroundColor: getTypeColor(notification.type),
                        // fontSize: '11px',
                      }}
                    />
                  </TableCell>
                  
                  <TableCell align="left" sx={tableStyles.messageCell}>
                    <Tooltip title={notification.message} arrow>
                      <span>{notification.message}</span>
                    </Tooltip>
                  </TableCell>
                  
                  <TableCell align="center">
                    <Chip
                      label={
                        notification.status.charAt(0).toUpperCase() +
                        notification.status.slice(1)
                      }
                      sx={{
                        ...commonStyles.chip,
                        backgroundColor: getStatusColor(notification.status),
                      }}
                    />
                  </TableCell>
                  
                  <TableCell align="center">
                    <Chip
                      label={
                        notification.severity.charAt(0).toUpperCase() +
                        notification.severity.slice(1)
                      }
                      sx={{
                        ...commonStyles.chip,
                        backgroundColor: getSeverityColor(notification.severity),
                      }}
                    />
                  </TableCell>
                  
                  <TableCell align="center">
                    <div>
                      <div>
                        {dayjs(notification.created_at).format('DD-MM-YYYY')}
                      </div>
                      <div style={tableStyles.dateCell}>
                        {dayjs(notification.created_at).format('HH:mm:ss')}
                      </div>
                    </div>
                  </TableCell>
                  
                  {/* <TableCell align="center">
                    <Chip
                      label={notification.emailSent ? 'Sent' : 'Not Sent'}
                      sx={{
                        ...commonStyles.chip,
                        backgroundColor: getEmailColor(notification.emailSent),
                      }}
                    />
                  </TableCell> */}
                  
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          onViewNotification(notification);
                        }}
                        sx={commonStyles.viewButton}
                      >
                        View
                      </Button>
                      
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, notification.id)}
                        sx={{ color: '#5968b7' }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
            
            {notifications.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={tableStyles.emptyRow}>
                  No notifications found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Loading overlay */}
        {loading && notifications.length > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </TableContainer>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={(event, value) => onPageChange(value)}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      {/* Pagination Info */}
      {notifications.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
          <Typography variant="body2" color="textSecondary">
            Showing {((pagination.currentPage - 1) * pagination.limit) + 1} to{' '}
            {Math.min(pagination.currentPage * pagination.limit, pagination.totalCount)} of{' '}
            {pagination.totalCount} notifications
          </Typography>
        </Box>
      )}

      {/* Context Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: { minWidth: 160 }
        }}
      >
        <MenuItem onClick={handleMarkAsResolved}>
          <CheckIcon sx={{ mr: 1, fontSize: 18 }} />
          Mark as Resolved
        </MenuItem>
        <MenuItem onClick={handleMarkAsActive}>
          <PlaylistAddCheckIcon sx={{ mr: 1, fontSize: 18 }} />
          Mark as Active
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default NotificationTable;